export class ValidServiceAddress implements ng.IDirective{
    public restrict = "A";
    public require = "ngModel";

    public link = (scope: any, element: any, attrs: any, ngModelCtrl: any) => {
        $(() =>{
            ngModelCtrl.$validators.validServiceAddress = (modelValue, viewValue):boolean =>{
                if(modelValue == null || modelValue == '') return true;
                return !/.*,.*|.*c\/o.*|.*PO Box.*|.*POBox.*/ig.test(modelValue);
            };
        });
    }
}